import React, { useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  TextField, Button, Alert,
} from '@mui/material';
import { scoutService } from '../../services/scoutService';

interface Props {
  open: boolean;
  onClose: () => void;
  athleteUuid: string;
  onSent?: (threadId: string) => void;
}

const ScoutForm: React.FC<Props> = ({ open, onClose, athleteUuid, onSent }) => {
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [sending, setSending] = useState(false);
  const [error, setError] = useState('');

  const handleSend = async () => {
    if (!subject.trim() || !message.trim()) {
      setError('件名とメッセージを入力してください');
      return;
    }
    setSending(true);
    setError('');
    try {
      const res = await scoutService.send({ athleteUuid, subject, message });
      onSent?.(res.threadId);
      onClose();
      setSubject('');
      setMessage('');
    } catch (err: any) {
      setError(err.response?.data?.message || 'スカウト送信に失敗しました');
    } finally {
      setSending(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>スカウトメッセージを送信</DialogTitle>
      <DialogContent>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        <TextField
          label="件名"
          fullWidth
          value={subject}
          onChange={(e) => setSubject(e.target.value)}
          sx={{ mb: 2, mt: 1 }}
        />
        <TextField
          label="メッセージ"
          fullWidth
          multiline
          rows={6}
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder="アスリートに向けてメッセージを入力してください。個人を特定できる情報は含まないようご注意ください。"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>キャンセル</Button>
        <Button variant="contained" onClick={handleSend} disabled={sending}>
          {sending ? '送信中...' : 'スカウトを送信'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ScoutForm;
